import { BACKEND_URL } from "../../lib/api";
import { useState } from "react";
import { ManagePhotosDialog } from "./ManagePhotosDialog";

const resolveImg = (url) => (url && url.startsWith("/api") ? `${BACKEND_URL}${url}` : url);

export const ArtistArtworkGrid = ({ artworks, onDelete, onAuction, onUpdated }) => {
  const [managing, setManaging] = useState(null);
  return (
    <>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {artworks.map((art) => {
          const galleryCount = (art.gallery || []).length;
          return (
            <div key={art.id} data-testid={`my-artwork-${art.id}`} className="border border-[#E5E0D8]">
              <div className="aspect-square bg-[#F2EDE5] relative">
                <img src={resolveImg(art.image_url)} alt={art.title} className="w-full h-full object-cover" />
                {art.status === "draft" && (
                  <span
                    data-testid={`draft-badge-${art.id}`}
                    className="absolute top-2 left-2 label-eyebrow bg-[#F4C430] text-[#1E3A8A] px-2 py-1"
                  >
                    PENDING REVIEW
                  </span>
                )}
                {galleryCount > 0 && (
                  <span
                    data-testid={`gallery-count-${art.id}`}
                    className="absolute bottom-2 right-2 label-eyebrow bg-white/90 text-[#1E3A8A] px-2 py-1"
                  >
                    +{galleryCount} photo{galleryCount === 1 ? "" : "s"}
                  </span>
                )}
              </div>
              <div className="p-4">
                <h3 className="font-serif-display text-xl">{art.title}</h3>
                <p className="font-mono-aam text-xs mt-1">
                  ${art.price.toLocaleString()} · {art.sold ? "SOLD" : art.status === "draft" ? "Awaiting admin approval" : "Available"}
                </p>
                <div className="mt-3 flex gap-3 items-center flex-wrap">
                  {!art.sold && art.status !== "draft" && (
                    <button
                      onClick={() => onAuction(art)}
                      data-testid={`auction-artwork-${art.id}`}
                      className="label-eyebrow text-[#1E3A8A] hover:text-[#111]"
                    >
                      List for auction
                    </button>
                  )}
                  {!art.sold && (
                    <button
                      onClick={() => setManaging(art)}
                      data-testid={`manage-photos-${art.id}`}
                      className="label-eyebrow text-[#1E3A8A] hover:text-[#111]"
                    >
                      Manage photos
                    </button>
                  )}
                  <button
                    onClick={() => onDelete(art.id)}
                    data-testid={`delete-artwork-${art.id}`}
                    className="label-eyebrow text-[#555] hover:text-[#D32F2F]"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <ManagePhotosDialog
        artwork={managing}
        open={!!managing}
        onClose={() => setManaging(null)}
        onSaved={(updated) => {
          onUpdated?.(updated);
          setManaging(null);
        }}
      />
    </>
  );
};
